import React, { useContext, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import StepperContext from '../stepper-context';

const StepperTitlesList = ({ children }) => {
  const { activeStepId, titlesListRef, titlesListWrapperRef } = useContext(StepperContext);

  const activeItemIndex = Children.toArray(children).findIndex(
    (child) => child.props.id === activeStepId
  );
  const enhancedChildren = Children.map(children, (child, index) => {
    const isHidden = index - 1 > activeItemIndex || index + 1 < activeItemIndex;

    return cloneElement(child, { isHidden });
  });

  return (
    <div className="ws-stepper__titles-list-wrapper" ref={titlesListWrapperRef}>
      <div className="ws-stepper__titles-list" ref={titlesListRef}>
        {enhancedChildren}
      </div>
    </div>
  );
};

StepperTitlesList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepperTitlesList;
